// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__fY1jr","spinner":"loader_spinner__8QBRS","s3":"loader_s3__uSeWp"};